import { logisticsHttp } from './http';
import { AddressModel } from 'models';
import { isApiError, BasketApiErrorModel } from 'models/Errors';
import { errorToBasketErrorModel } from 'helpers';

export class LogisticsRepository {
    public async getAddresses(postcode: string): Promise<AddressModel[]> {
        try {
            const url = `/postcode/${postcode}`;
            const response = await logisticsHttp.get(url);

            return this.parseAddressesLookup(response.data.Address);
        } catch (error) {
            const errorSource = 'logistics.repository:getAddresses';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }

    private parseAddressesLookup(data: DeliveryAddressesResponseModel): AddressModel[] {
        if (data.Numbers === undefined) {
            return [];
        }

        this.replaceAndChar(data.Street);
        this.replaceAndChar(data.Buildings);
        this.replaceAndChar(data.Town);
        this.replaceAndChar(data.County);

        let numbers = (data.Numbers || '').split(';');
        let buildings = (data.Buildings || '').split(';');
        let flats = (data.Flat || '').split(';');

        let addressesCount = Math.max(numbers.length, buildings.length, flats.length);

        let addresses: AddressModel[] = [];
        for (let addressIndex = 0; addressIndex < addressesCount; addressIndex++) {
            addresses.push(new AddressModel(
                this.tryGetNotEmptyStringValue(flats[addressIndex]),
                this.tryGetNotEmptyStringValue(buildings[addressIndex]),
                this.tryGetNotEmptyStringValue(numbers[addressIndex]),
                this.tryGetNotEmptyStringValue(data.Street),
                this.tryGetNotEmptyStringValue(data.Town),
                this.tryGetNotEmptyStringValue(data.Locality),
                this.tryGetNotEmptyStringValue(data.County) ?? this.tryGetNotEmptyStringValue(data.Town),
                this.tryGetNotEmptyStringValue(data.Postcode)
            ));
        }

        return addresses;
    }

    private tryGetNotEmptyStringValue(val: string | null | undefined): string | null {
        return (val && val.length > 0) ? val : null;
    }

    private replaceAndChar(value: string | null | undefined): string | null | undefined {
        if (value) {
            return value.replace(new RegExp('&', 'g'), ' and ');
        }

        return value;
    }
}

interface DeliveryAddressesResponseModel {
    Street?: string;
    Town?: string;
    Locality?: string;
    County?: string;
    Postcode?: string;
    Numbers?: string;
    Buildings?: string;
    Flat?: string;
}

export const logistics = new LogisticsRepository();